type ExcludesFalse = <T>(x: T | undefined | null | false) => x is T

/**
 * Filters out falsy values from an array.
 *
 * This is mainly used to work with type narrowing especially in CTF types.
 */
export const filterFalsy = <T>(array: (T | undefined | null | false)[]): T[] => {
  return array.filter(Boolean as any as ExcludesFalse)
}

/**
 * Checks if two arrays are shallowly equal on the first level
 */
export const isShallowEqual = <T>(a: T[], b: T[]): boolean => {
  if (a.length !== b.length) return false
  for (let i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) return false
  }
  return true
}

export const removeAtIndex = <T>(array: T[], index: number): T[] => {
  if (index < 0 || index >= array.length) {
    return [...array] // return a shallow copy if index is invalid
  }
  return [...array.slice(0, index), ...array.slice(index + 1)]
}
